import React, { useEffect, useRef, useState } from 'react'
import { BarBlock, BarContainer, CellContainer, ShadowWrap, StyledTypography, TooltipColName, ToolTipContainer, TooltipRowName } from './style'
import { LEGEND_TEXT_COLOR_MAP } from '../../../../constants'
import { Standout, IconRedArrowV2, IconGreenArrowV2, IconMixedV2, IconNegativeV2, IconPositiveV2, StandoutV2 } from '../../../../assets/images/icons'

const LandscapeCell = ({ 
  legends,
  column,
  isLastColumn,
  expandView = false,
  rowName,
  colName,
  onMouseEnter,
  onMouseLeave,
  colors,
  sorting,
  isFirstColumn
}) => {
  const negative = column?.find((item) => item.ImageryIndexSentiment === 'Negative')
  const positive = column?.find((item) => item.ImageryIndexSentiment === 'Positive')
  const neutral = column?.find((item) => item.ImageryIndexSentiment === 'Neutral')
  const mixed = column?.find((item) => item.ImageryIndexSentiment === 'Mixed')
  const ref = useRef();

  let borderColor = 'transparent'
  if (negative && !positive && !neutral) {
    borderColor = 'rgba(238, 37, 52, 1)'
  } else if (positive && !negative && !neutral) {
    borderColor = 'rgba(33, 185, 121, 1)' // '#00B050' + 50;
  } else if (neutral && !positive && !negative) {
    if (neutral.InsightName !== '') {
      // borderColor = '#f5bd4fb8';
      borderColor = 'transparent'
    }
  }

  const handleMouseEnter = () => {
    if (onMouseEnter) {
      onMouseEnter(column, rowName, colName, ref.current, isLastColumn , isFirstColumn);
    }
  };

  const handleMouseLeave = () => {
    if (onMouseLeave) {
      onMouseLeave();
    }
  };

  // const sortData = (data) => {
  //   const finalData = sorting(data)
  //   if(finalData.length <= 1) { return finalData }
  //   console.log('finalData ------------> ', finalData)
  //   return finalData
  // }

  return (
    expandView ? 
    <ShadowWrap
      isSentiment={negative || positive || neutral || mixed || !column}
      isLastColumn={isLastColumn}
      leftBorderColor={borderColor}
    >
      {!column && <StyledTypography>{column}</StyledTypography>}
      {column?.length > 0 &&
        sorting(column)?.map((item, index) => {
          // const insightSentiment = item.InsightSentiment === "Mixed" && '%7e' || item.InsightSentiment === "Negative" && '%2d' || item.InsightSentiment === "Positive" && '%2b' || ''
          return (
            <StyledTypography
              component="span"
              className={`textItemShadow legends_${legends.length}`}
              key={item.InsightName + index}
              fontcolor={
                item.InsightSentiment === 'Mixed'
                  ? 'rgba(99, 107, 115, 1)'
                  : colors[item.InsightSentiment]
              }
              // background={item.InsightSentiment && item.InsightName && item?.InsightStandout}
            >
              {(item.InsightSentiment === 'Mixed' && <IconMixedV2 />) ||
                (item.InsightSentiment === 'Negative' && <IconNegativeV2 />) ||
                (item.InsightSentiment === 'Positive' && <IconPositiveV2 />)}
              <label>
                {item.InsightName || ''}
              </label>

              {/* <label dangerouslySetInnerHTML={{__html: `${insightSentiment}${item.InsightName || ''}`}}></label> */}

              {/* {item.InsightSentiment === "Mixed" && <label>%7e{item.InsightName || ''}</label>}
            {item.InsightSentiment === "Negative" && <label>%2d{item.InsightName || ''}</label>}
            {item.InsightSentiment === "Positive" && <label>%2b{item.InsightName || ''}</label>} */}

              {/* {item.InsightSentiment === "Mixed" && <label>{ decodeURIComponent('%7e'+(item.InsightName || '')) }</label>}
            {item.InsightSentiment === "Negative" && <label>{ decodeURIComponent('%2d'+(item.InsightName || '')) }</label>}
            {item.InsightSentiment === "Positive" && <label>{ decodeURIComponent('%2b'+(item.InsightName || '')) }</label>} */}

              {/* {index !== (column.length - 1) ? ',' : ''} */}
              {/* {(item.InsightSentiment && item.InsightName) && item?.InsightStandout && <span><Standout /></span>} */}
              {item.InsightSentiment && item.InsightName && item?.InsightStandoutType === 'New' && (
                <span>
                  <StandoutV2 />
                </span>
              )}
              {item.InsightSentiment && item.InsightName && item?.InsightStandoutType === 'Up' && (
                <span>
                  <IconGreenArrowV2 />
                </span>
              )}
              {item.InsightSentiment &&
                item.InsightName &&
                item?.InsightStandoutType === 'Down' && (
                  <span>
                    <IconRedArrowV2 />
                  </span>
                )}
            </StyledTypography>
          )
        })}
    </ShadowWrap>
    : 
      <BarContainer
        ref={ref}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave} 
       >
      <BarBlock className='barBlock' barColor={borderColor} />
    </BarContainer> 
     
  )
}

export default LandscapeCell
